<template>
  <div class="enter-phone-refinance">
    <TextInput
      :value="phoneNumber"
      :onInput="onPhoneNumberChange"
      inputType="tel"
      autocomplete="mobile tel"
      placeholder=""
      :error-message="errorMessage" />
    <RiseupButton
      class="submit-button"
      :title="'בואו נתחיל'"
      :action="onSubmit"
      :size="'large'"
      :variant="'primary'"
      :color="'green'"
      :disabled="!isPhoneValid" />
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'EnterPhoneNumberReFinance',
  components: {
    TextInput: BaseUI.V2Components.TextInput,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      phoneNumber: '',
      localError: null,
    };
  },
  computed: {
    errorMessage() {
      if (this.error) {
        return this.error;
      }
      if (this.localError) {
        return this.localError;
      }
      return null;
    },
    isPhoneValid() {
      const cleaned = this.phoneNumber.replace(/\D/g, '');
      // Israeli mobile: 05XXXXXXXX (10 digits) or 9725XXXXXXXX (12 digits with country code)
      return /^05\d{8}$/.test(cleaned) || /^9725\d{8}$/.test(cleaned);
    },
  },
  methods: {
    onPhoneNumberChange(value) {
      this.phoneNumber = value;
      this.localError = null;
      this.$emit('phone-changed', value);
    },
    onSubmit() {
      if (!this.phoneNumber) {
        this.localError = 'נא להזין מספר טלפון';
        return;
      }
      this.$emit('submit', this.phoneNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
.enter-phone-refinance {
  width: 100%;
  padding: 16px;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep {
    .text-input,
    .text-input-wrapper,
    .input-wrapper,
    div {
      background-color: transparent !important;
      background: transparent !important;
    }

    input {
      background-color: transparent !important;
      height: 56px !important;
      font-size: 18px !important;
      padding: 16px !important;
      width: 345px !important;
    }
  }

  .submit-button {
    margin-top: 16px;
    width: 345px;
  }
}
</style>
